export default __webpack_public_path__ + "static/media/star-not-favorite-active.8737ad5c.svg";